import {appContainer} from "../contexts/app";
import Resource from "./resource";
import {List} from "immutable";

import {orderById} from "../lib";

export default (markerService, InfographicRecord) => {
  return Resource(
    markerService,
    {
      account_id: "",
      // Markers can belong to floors or facilities
      // The presence of either _id dictates its type,
      // floor-marker or facility-marker
      floor_id: "",
      name: "",
      type_id: "",
      geo: {},
      infographics_order: []
    },
    {
      async infographics() {
        const {data: infographics} = await InfographicRecord.find({
          query: {marker_id: this._id}
        });
        if (!infographics) {
          return List();
        }
        const filtered = infographics
          .toList()
          // Filter the infographics by those in the infographics_order array
          .filter(infographic => {
            return this.infographics_order.includes(infographic._id);
          });
        // Sort the infographics in order
        return orderById(filtered, this.infographics_order);
      },

      selectOptions() {
        const markerTypes = appContainer.state.get("markerTypes");
        const categories = appContainer.state.get("markerTypeCategories");
        return (
          markerTypes
            .toList()
            // Sort by category name
            .sort((a, b) => {
              const textA = categories.get(a.category_id).name.toUpperCase();
              const textB = categories.get(b.category_id).name.toUpperCase();
              return textA < textB ? -1 : textA > textB ? 1 : 0;
            })
            // Turn into shape consumable by FieldSelect
            .map(type => ({
              value: type._id,
              text: type.name,
              secondaryText: categories.get(type.category_id).name,
              image: type.image.path
            }))
        );
      },

      type() {
        return appContainer.state.getIn(["markerTypes", this.type_id]);
      }
    }
  );
};



// WEBPACK FOOTER //
// ./src/feathers/marker-record.js